import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AlertDto, AlertStatus } from '../models/alerts.models';

type AlertsListParams = {
  project_id: string;
  status?: AlertStatus;
};

type AlertsExcelDto = {
  report: string;
  generated_at: number;
  file_name: string;
  mime_type: string;
  content: string;
};

@Injectable({ providedIn: 'root' })
export class AlertsApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  list(params: AlertsListParams) {
    const search = new URLSearchParams();
    search.set('project_id', params.project_id);
    if (params.status) search.set('status', params.status);
    return this.http.get<AlertDto[]>(`${this.baseUrl}/alerts?${search.toString()}`);
  }

  exportExcel(params: AlertsListParams) {
    const search = new URLSearchParams();
    search.set('project_id', params.project_id);
    if (params.status) search.set('status', params.status);
    return this.http.get<AlertsExcelDto>(`${this.baseUrl}/alerts/excel?${search.toString()}`);
  }

  updateStatus(id: string, status: AlertStatus, observation?: string | null) {
    return this.http.patch<AlertDto>(`${this.baseUrl}/alerts/${encodeURIComponent(id)}`, {
      status,
      observation: observation?.trim() ? observation.trim() : undefined,
    });
  }
}
